import App from "../app";
import Home from "../pages/home";
import Moderation from "../../pages/moderation";
import Signup from "../../pages/signup";
import Login from "../../pages/login";
import SignupProfile from "../pages/signup-profile";
import Terms from "../pages/terms";
import Account from "../../pages/account";
import Choirs from "../pages/choirs";
import Practice from "../pages/practice";
import Edit from "../pages/edit";
import Privacy from "../../pages/privacy";
import Contact from "../../pages/contact";
import PasswordRecovery from "../../pages/password-recovery";
import Verify from "../../pages/verify";
import NotFound from "../pages/404";
import routing from "../../routing";

export default [
    {
        ...App,
        path: `/${routing.memory}`,
        routes: [
            {
                ...Home,
                path: `/${routing.memory}`,
                exact: true,
            },
            {
                ...Moderation,
                path: `/${routing.memory}/${routing.moderation}`,
            },
            {
                ...Signup,
                path: `/${routing.memory}/${routing.signup}`,
            },
            {
                ...Login,
                path: `/${routing.memory}/${routing.login}`,
            },
            {
                ...Terms,
                path: `/${routing.memory}/${routing.terms}`,
            },
            {
                ...SignupProfile,
                path: `/${routing.memory}/${routing.signupProfile}`,
            },
            {
                ...Account,
                path: `/${routing.memory}/${routing.account}`,
            },
            {
                ...Choirs,
                path: `/${routing.memory}/${routing.choirs}`,
            },
            {
                ...Practice,
                path: `/${routing.memory}/${routing.practice}/:id`,
            },
            {
                ...Edit,
                path: `/${routing.memory}/${routing.editPiece}/:id`,
            },
            {
                ...Privacy,
                path: `/${routing.memory}/${routing.privacy}`,
            },
            {
                ...Contact,
                path: `/${routing.memory}/${routing.contact}`,
            },
            {
                ...PasswordRecovery,
                path: `/${routing.memory}/${routing.passwordRecovery}`,
            },
            {
                ...Verify,
                path: `/${routing.memory}/${routing.verify}`,
            },
            {
                ...NotFound,
            },
        ],
    },
];
